import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://pnbalqjlkdxykwnupodr.supabase.co";
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBuYmFscWpsa2R4eWt3bnVwb2RyIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODEwNTcwMzgsImV4cCI6MTk5NjYzMzAzOH0.QaOXkWx6UjiSvEt-hLrII8tVyT7AooIQnVAAr_qjUiY";
const supabase = createClient(supabaseUrl,  supabaseKey);

export default supabase;